import { HStack, Text } from "components/ui";
import { User } from "lucide-react-native";
import React from "react";
import { useIsMobile } from "utils/hooks/useIsMobile";

const UserLabel = ({ firstname, lastname }: { firstname: string; lastname: string }) => {
	const isMobile = useIsMobile();
	return (
		<HStack bg="$neutral25" borderRadius={4} alignSelf="flex-start" paddingHorizontal={isMobile ? 0 : 12} paddingVertical={8} gap={6}>
			<User width={14} height={14} color="black" />
			<Text fontSize={12}>
				{firstname} {lastname}
			</Text>
		</HStack>
	);
};

export default UserLabel;
